import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OfferModel } from '../../shared/models/payment/offer.model';
import { ItemModel } from '../../shared/models/payment/order/item.model';
import { SubscriptionModel } from '../../shared/models/payment/subscription/subscription.model';
import { OrderModel } from '../../shared/models/payment/order/order.model';
import { Ng2DeviceService } from 'ng2-device-detector';

@Component({
    selector: 'completed-ebit-banner',
    templateUrl: './completed.ebit-banner.component.html',
    styleUrls: ['./../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedEbitBannerComponent implements AfterViewInit, OnInit {
    private static PAYMENT_TYPE_CREDIT_CARD = '05';
    private static PAYMENT_TYPE_BANK_SLIP = '08';
    private static PAYMENT_TYPE_OTHER = '14';
    private static PAYMENT_TYPE_DEBIT_CARD = '28';
    private static PAYMENT_TYPE_PIX = '90';

    private static PLATFORM_MOBILE = '1';
    private static PLATFORM_DESKTOP = '0';

    private static CONDITION_NEW = '0';
    private static CONDITION_USED = '1';

    private static FLAG_AMEX = '1';
    private static FLAG_AURA = '2';
    private static FLAG_DINERS_CLUB = '3';
    private static FLAG_HIPERCARD = '4';
    private static FLAG_MASTERCARD = '5';
    private static FLAG_VISA = '6';
    private static FLAG_OTHER = '7';
    private static FLAG_ELO = '8';

    @Input('ebitStoreId') ebitStoreId;
    @Input('offerable') offerable;

    public paramValue = '';

    constructor(private deviceService: Ng2DeviceService) { }

    ngOnInit() {
        this.paramValue = `storeId=${this.ebitStoreId}`
                        + `&transactionId=${this.offerable.id}`
                        + `&platform=${this.platform()}`
                        + `&parcels=${this.parcels()}`
                        + `&deliveryTax=${this.offerable.freight}`
                        + `&totalSpent=${this.offerable.total}`
                        + this.zipCode()
                        + this.deliveryTime()
                        + `&value=${this.values()}`
                        + `&quantity=${this.quantities()}`
                        + `&productName=${this.productNames()}`
                        + `&paymentType=${this.paymentType()}`
                        + `&sku=${this.skus()}`
                        + `&productCondition=${this.productConditions()}`
                        + `&deliveryType=6`
                        + `&mktSaleId=0`
                        + `&ean=${this.eans()}`
                        + `&cardFlag=${this.cardFlag()}`;
    }

    ngAfterViewInit() {
        const node = document.createElement('script');
        node.src = 'https://imgs.ebit.com.br/ebitBR/selo-ebit/js/getSelo.js?'
            + this.ebitStoreId
            + '&lightbox=true';
        node.id = 'getSelo';
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);
    }

    private platform() {
        if (this.deviceService.isMobile()) {
            return CompletedEbitBannerComponent.PLATFORM_MOBILE;
        }

        return CompletedEbitBannerComponent.PLATFORM_DESKTOP;
    }
    private parcels() {
        if (
            this.offerable.payment_card === undefined
            || this.offerable.payment_card === null
        ) {
            return 1;
        }

        return this.offerable.payment_card.installments;
    }
    private zipCode() {
        if (
            this.offerable.deliveries === undefined
            || this.offerable.deliveries === null
        ) {
            return '';
        }

        return `&zipCode=${this.offerable.deliveries.address.zip_code}`;
    }
    private deliveryTime() {
        if (
            this.offerable.deliveries === undefined
            || this.offerable.deliveries === null
        ) {
            return '';
        }

        return `&deliveryTime=${this.offerable.deliveries.zip_code_range.deadline}`;
    }
    private values() {
        if (this.offerable.plan !== undefined) {
            return this.offerable.plan.amount;
        }

        return this.offerable.items.map((item: ItemModel) => {
            return item.total_price;
        }).join('|');
    }
    private quantities() {
        if (this.offerable.plan !== undefined) {
            return 1;
        }

        return this.offerable.items.map((item: ItemModel) => {
            return item.quantity;
        }).join('|');
    }
    private productNames() {
        if (this.offerable.plan !== undefined) {
            return this.offerable.plan.description;
        }

        return this.offerable.items.map((item: ItemModel) => {
            return item.item.name;
        }).join('|');
    }
    private paymentType() {
        if (this.offerable.payment_method.type === 'bank slip') {
            return CompletedEbitBannerComponent.PAYMENT_TYPE_BANK_SLIP;
        }
        if (this.offerable.payment_method.type === 'credit card') {
            return CompletedEbitBannerComponent.PAYMENT_TYPE_CREDIT_CARD;
        }
        if (this.offerable.payment_method.type === 'debit card') {
            return CompletedEbitBannerComponent.PAYMENT_TYPE_DEBIT_CARD;
        }
        if (this.offerable.payment_method.type === 'pix') {
            return CompletedEbitBannerComponent.PAYMENT_TYPE_PIX;
        }

        return CompletedEbitBannerComponent.PAYMENT_TYPE_OTHER;
    }
    private skus() {
        if (this.offerable.plan !== undefined) {
            return this.offerable.plan.id;
        }

        return this.offerable.items.map(item => {
            return item.item.sku;
        }).join('|');
    }
    private eans() {
        if (this.offerable.plan !== undefined) {
            return this.offerable.plan.id;
        }

        return this.offerable.items.map(item => {
            return item.item.ean;
        }).join('|');
    }
    private productConditions() {
        if (this.offerable.plan !== undefined) {
            return CompletedEbitBannerComponent.CONDITION_NEW;
        }

        return this.offerable.items.map(item => {
            return CompletedEbitBannerComponent.CONDITION_NEW;
        }).join('|');
    }
    private cardFlag() {
        if (this.offerable.payment_method.type !== 'credit card') {
            return CompletedEbitBannerComponent.FLAG_OTHER;
        }

        if (this.offerable.payment_card.brand === 'visa') {
            return CompletedEbitBannerComponent.FLAG_VISA;
        }
        if (this.offerable.payment_card.brand === 'mastercard') {
            return CompletedEbitBannerComponent.FLAG_MASTERCARD;
        }
        if (this.offerable.payment_card.brand === 'elo') {
            return CompletedEbitBannerComponent.FLAG_ELO;
        }
        if (this.offerable.payment_card.brand === 'amex') {
            return CompletedEbitBannerComponent.FLAG_AMEX;
        }
        if (this.offerable.payment_card.brand === 'aura') {
            return CompletedEbitBannerComponent.FLAG_AURA;
        }
        if (this.offerable.payment_card.brand === 'diners') {
            return CompletedEbitBannerComponent.FLAG_DINERS_CLUB;
        }
        if (this.offerable.payment_card.brand === 'hipercard') {
            return CompletedEbitBannerComponent.FLAG_HIPERCARD;
        }
        return CompletedEbitBannerComponent.FLAG_OTHER;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/completed/ebit-banner/completed.ebit-banner.component.ts